import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ClubServicesService } from '../../services/club-services.service';
import { CardDetailsService } from '../../services/card-details.service';
import { ConfirmationCancelComponent } from '../confirmation-cancel/confirmation-cancel.component';
import { RestaurantService } from '../../services/restaurant-services.';

@Component({
  selector: 'app-confirmation-dialogue',
  templateUrl: './confirmation-dialogue.component.html',
  styleUrls: ['./confirmation-dialogue.component.scss']
})
export class ConfirmationDialogueComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private csObj: CommonService,
    private toast: ToastrService,
    private router: Router,
    private dialogRef: MatDialog,
    private auth: AuthService,
    private  spinner: SpinnerVisibilityService,
    private clubServ: ClubServicesService,
    private carDetailsService: CardDetailsService,
    private restoService: RestaurantService
  ) { }

  defaultImage = '../../../../assets/icons/Loading_icon.gif';

  ngOnInit(): void {
  }

  // Delete teams functionality
  DeletBtnClick() {
    try {
      this.csObj.deleteAPI(this.data.userType.id).subscribe((res: any) => {
        this.toast.success("Team Deleted successfully");
        this.csObj.callTeamList(true);
        // let currentURL = this.router.url
        // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
        //   this.router.navigate([currentURL]);
        // });

      },
        (err: any) => {
          this.toast.error(err.message);
        })
    }
    catch (e) { }
  }

  deleteCardConfirm(){
    this.carDetailsService.deleteCard(this.data.userType.id).subscribe(
      () => {
        this.toast.success("Card Deleted successfully");
        this.csObj.getAllUsersCardsList(true);
        // let currentURL = this.router.url
        // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
        //   this.router.navigate([currentURL]);
        // });
      },
      (error) => {
        console.error('Error deleting card:', error);
        this.toast.error(error.error.error.message);
      }
    );
  }


   // logout  functionality
  logoutClick() {
    try {
      localStorage.removeItem('currentUser')
      this.spinner.show();
      this.auth.logoutFN();
     }
    catch (e) { }
  }

  EvenctDeletOk(id:any){
    const dialogRef = this.dialogRef.open(ConfirmationCancelComponent, {
      id: 'delete-team-confirm',
      hasBackdrop: true,
      disableClose: true,
      width: '469px',
      data: {
        userType: {
          titleOne: 'Do you want to cancel the order for this event?',
          text: "Please check the order details in the 'Manage Orders' tab on the left panel.",
          imgPath: '../../../assets/icon/delete -icon.png',
          access: "EventDelete",
          id: id
        }
      },
    });
    // this.clubServ.deleteTeam(id).subscribe(
    //   () => {
    //     this.toast.success("Event Canceled successfully");
    //     let currentURL = this.router.url
    //     this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
    //       this.router.navigate([currentURL]);
    //     });
    //     console.log('Team deleted successfully');
    //   },
    //   (error) => {
    //     console.error('Error deleting team:', error);
    //   }
    // );
  }

  declineOrderConfirm(id:any){
    this.restoService.cancleOrderByResto({orderId:id}).subscribe((res:any)=>{
      if(res.status == 200){
        // this.confirmDelieved = true;
        (<HTMLInputElement>document.getElementById('declineBtnNewOrder')).style.display = 'none';
        (<HTMLInputElement>document.getElementById('acceptBtnNewOrder')).style.display = 'none';
        (<HTMLInputElement>document.getElementById('declinedBtnNewOrder')).style.display = 'block';
      }
    })
  }

  deleteStripeAccount(){
    this.restoService.unlinkToStripe().subscribe((res:any)=>{
      if(res.status == 200){
          this.toast.success("Account deleted successfully");
          location.reload();
      }
    })
  }

  connectToStripe(){
    this.router.navigateByUrl('/bankingDetails')
  }

}
